/** @jsxImportSource @emotion/react */

import {
  ButtonStyled,
  ModalActionsStyled,
  ModalStyled,
  TextStyled,
  useWindowWidth
} from '@nike/nike-design-system-components';
import { useDispatch, useSelector } from 'react-redux';
import { nike } from '@nike/nike-design-tokens';
import { useEffect } from 'react';

import InvitationForm from './InvitationForm';
import UserManagementErrorSnackbar from '../UserManagementErrorSnackbar';
import UserManagementLoadingAnimation from '../UserManagementLoadingAnimation';

import { TranslatedCopy } from '../../intl/TranslatedCopy';
import { invitationsActions } from './actions';
import { invitationsSelectors } from './reducer';
import { requestsActions } from '../../requests/actions';
import { requestsSelectors } from '../../requests/reducer';

const InvitationModal = () => {
  const dispatch = useDispatch();

  const invitationError = useSelector(requestsSelectors.invitationError);
  const invitationSuccess = useSelector(requestsSelectors.invitationSuccess);
  const startInvitation = useSelector(invitationsSelectors.startInvitation);

  const isMobile = useWindowWidth() < 769;

  useEffect(() => {
    if (invitationSuccess) {
      dispatch({ type: invitationsActions.cancelInvitation.name });
    }
  }, [invitationSuccess]);

  return (
    <ModalStyled
      appearance={isMobile ? 'fullscreen' : 'base'}
      closeModal={() => {
        dispatch({ type: invitationsActions.cancelInvitation.name });

        if (invitationError) {
          dispatch({ type: requestsActions.clearInvitationError.name });
        }
      }}
      css={{
        '@media (min-width: 769px)': {
          borderRadius: '5px',
          maxWidth: '1010px'
        }
      }}
      isOpen={startInvitation}
      slots={{
        FooterSlot: (
          <ModalActionsStyled>
            <ButtonStyled disabled={invitationError} form='userInvitation' type='submit'>
              <TranslatedCopy id='userManagement.button.add' />
            </ButtonStyled>
          </ModalActionsStyled>
        )
      }}
      title={new TranslatedCopy({
        id: 'userManagement.button.add'
      }).toString()}
      modalHeaderCompProps={{ style: { paddingBottom: '10px' } }}
      modalContentCompProps={{ style: { overflowY: 'scroll' } }}
    >
      <TextStyled appearance='body2' color={nike.podiumCdsColorTextSecondary}>
        <TranslatedCopy id='userManagement.addUser.invite1' />
      </TextStyled>
      <TextStyled appearance='body2' color={nike.podiumCdsColorTextSecondary}>
        <TranslatedCopy id='userManagement.addUser.invite2' />
      </TextStyled>
      <InvitationForm />
      <UserManagementErrorSnackbar />
      <UserManagementLoadingAnimation />
    </ModalStyled>
  );
};

export default InvitationModal;
